import { useEffect, useRef, useState } from 'react';
import { debounce } from 'loadsh';
import YouTube from 'react-youtube';

import { NewsSection } from '../../components/home/NewsSection';
import { fadeText, Animate, fadeBtn } from '../../lib/home/utils';

import { Section } from '../../components/home/Section';
import { MediaSection } from '../../components/home/MediaSection';
import StellaSection from '../../components/home/StellaSection';
import { useLocation } from 'react-router-dom';
import { useLocale } from '../../lib/context/locale-context';

function Home() {
  const { getLocale, currentLocale } = useLocale();
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [hash]);

  const [popup, setPopup] = useState(false);
  const [, setNav] = useState(0);
  const youtubeRef = useRef(null);
  const [mWidth, setWidth] = useState(window.innerWidth);
  const [mHeight, setHeight] = useState(window.innerHeight);

  const handleResize = debounce(() => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
    document.documentElement.style.setProperty('--h', `${window.innerHeight / 100}px`);
  }, 300);

  useEffect(() => {
    if (popup) {
      youtubeRef.current.internalPlayer.playVideo();
    } else {
      youtubeRef.current.internalPlayer.stopVideo();
    }
  }, [popup]);

  useEffect(() => {
    const video = document.getElementById('bgVideo');

    video.addEventListener('loadeddata', () => {
      if (video.readyState === 4) {
        video.style.display = 'block';
      }
    });

    video.addEventListener('pause', () => {
      video.play();
    });
  });

  useEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return (
    <div className="home hero bg-white">
      <div id="fullPage" className="fullPage bg-[#343636] snap-y snap-mandatory">
        {/* Layered Popup */}
        <div
          className={`hero-overlay h-screen bg-opacity-90 absolute z-50 ${popup ? 'block' : 'hidden'}`}
          onClick={() => setPopup(false)}
        >
          <div
            className="w-screen flex flex-col absolute left-1/2 -translate-x-1/2 -translate-y-1/2"
            style={{ top: '40%', maxWidth: '100vh' }}
          >
            <div>
              <div className="flex flex-row justify-center pb-4">
                <div className="flex items-end">
                  <img className="max-w-xs z-30" src="/logo+text.svg" alt="logo" style={{ mWidth: '30vh' }} />
                </div>
              </div>
            </div>
            <YouTube
              ref={youtubeRef}
              videoId="l_XzGEr6dMI"
              className="aspect-video"
              iframeClassName="w-full h-full"
              opts={{
                playerVars: {
                  rel: 0, //관련 동영상 표시
                  modestbranding: 1, // 컨트롤 바에 youtube 로고를 표시하지 않음
                },
              }}
            />
          </div>
        </div>
        {/* Sections */}
        <div className="z-0 justify-center flex flex-col text-center text-neutral-content p-0 w-screen max-w-full transitionFastest">
          {/* Section0 */}
          <Section id="0" onFocus={(id) => setNav(id)} src="/bg-section01.webp">
            {/* Audition Button */}
            {/* <div className="fill absolute flex flex-col z-20 justify-center scale-100 bottom-24 sm:bottom-8 md:bottom-24 right-1/2 translate-x-1/2 sm:right-12 lg:right-16 xl:right-24 sm:translate-x-0 fadeIn fast">
              <a
                href="https://forms.gle/3no71aQN73VdtAgx7"
                target="_blank"
                rel="noreferrer"
                className="flex flex-row justify-between entryBtn px-[6vh] w-[34vh] h-[10vh]"
              >
                <span>오디션 지원</span>
                <div className="external w-[4vh] h-[4vh]" />
              </a>
            </div> */}
            {!popup && (
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 scale-100 cursor-pointer z-30">
                <div onClick={() => setPopup(true)}>
                  <Animate variants={fadeBtn}>
                    <img className="playBtn" src="/btn-play.svg" alt="play button" />
                  </Animate>
                </div>
              </div>
            )}
            <video autoPlay muted loop playsInline className="object-cover w-screen h-screen hidden" id="bgVideo">
              <source src="/bg-video.mp4" type="video/mp4" />
            </video>
            <div className="absolute left-1/2 bottom-4 -translate-x-1/2">
              <img
                className="z-30 animate-bounce fill-black"
                src="/scroll-down.svg"
                alt="stop button"
                style={{ width: '8vh' }}
              />
            </div>
          </Section>
          {/* Section 1 */}
          {/* <ScheduleSection id="1" onFocus={(id) => setNav(id)} src="./bg-section02.webp" w={mWidth} h={mHeight} /> */}
          {/* Section 2 */}
          <NewsSection w={mWidth} h={mHeight} setNav={setNav} />

          {/* Section3 */}
          <Section id="3" onFocus={(id) => setNav(id)} src="/bg-section02.webp">
            <div className="hero-overlay bg-opacity-50 absolute none z-20">
              <div className="section-content">
                <Animate variants={fadeText} delay={300}>
                  <h3 className={`${mWidth < mHeight ? 'my-[6vh]' : 'my-[8vh]'}`}>{getLocale('worldview.title')}</h3>
                </Animate>
                <Animate variants={fadeText} delay={600}>
                  <div className="w-[55vh] -space-y-1" style={{ fontSize: '1.7vh', lineHeight: '3.8vh' }}>
                    {
                      currentLocale.value === 'ko' 
                      ? (<>
                        <p>다양한 지식과 다른 차원의 이야기들을 책의 형태로 저장하는</p>
                        <p>도서관 「루체테」의 수많은 열람실 중 한 곳.</p>
                        <br />
                        <p>나 홀로 도서관의 이야기를 알리느라 고군분투하고 있는 사서에게</p>
                        <p>갑작스러운 「스텔라」의 출현으로 한 줄기 빛이 보이기 시작한다.</p>
                        <br />
                        <p>각자의 강한 염원과 꿈을 매개체로 삼아</p>
                        <p>책 속에서 도서관으로 넘어오게 된 「스텔라」</p>
                        <br />
                        <p>원하는 것을 이루기 위해 「스텔라」는 사서에게 도움을 청하지만,</p>
                        <p>도서관의 업무에 진절머리가 난 사서는</p>
                        <p>지식을 대가로 「스텔라」에게 도서관의 홍보를 요구한다.</p>
                        <br />
                        <p>사람들의 기억에서 잊힐수록 사라지는 도서관 「루체테」에서</p>
                        <p>얼떨결에 홍보대사 임무를 맡게 된 「스텔라」들의 이야기</p>
                      </>) 
                      : (<>
                      <p>さまざまな知識と、異なる次元の物語が“本”として収められている図書館――『ルチェッテ』。</p>
                      <br/>
                      <p>そこは、数えきれないほどの閲覧室を持つ、不思議な図書館の一室。</p>
                      <br/>
                      <p>
                        たったひとりで図書館の存在を広めようと奮闘していた司書の前に、
                        ある日突然『ステラ』たちが現れ、一筋の光が差し込み始める。
                      </p>
                      <br />
                      <p>
                        それぞれの強い願いと夢を媒介として、
                        本の世界から図書館へとやってきた『ステラ』たち。願いを叶えるため、ステラたちは司書に助けを求める。しかし、図書館の業務にうんざりしていた司書は、
                        “知識”を対価として、ステラたちに図書館の宣伝を要求する。人々の記憶から忘れ去られるほど、その存在が薄れていく図書館『ルチェッテ』。ひょんなことから広報大使という役目を任されることになった、ステラたちの物語。
                      </p>
                      </>)
                    }

                  </div>
                </Animate>
                <div className="absolute left-1/2 bottom-4 -translate-x-1/2">
                  <img
                    className="z-30 animate-bounce fill-black"
                    src="/scroll-down.svg"
                    alt="stop button"
                    style={{ width: '8vh' }}
                  />
                </div>
              </div>
            </div>
          </Section>

          {/* Section4 */}
          <Section id="4" onFocus={(id) => setNav(id)} src="/bg-section03.webp">
            <StellaSection w={mWidth} h={mHeight} />
          </Section>

          {/* Section5 */}
          {/* 로컬 환경에서 과부하가 심하게 걸림 */}
          <MediaSection w={mWidth} h={mHeight} setNav={setNav} />
        </div>
      </div>
    </div>
  );
}

export default Home;
